import React, { Component } from "react";
import { formatoSeparadorMilesValue } from '../../../generico/utils/FormatoInput'
import history from "../../login/history"
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import ConfigService from "../../../../services/configuracion/ConfigService";
import SubsidiosService from "../../../../services/solicitudes/SubsidiosService";
import SelectComponente from '../../../generico/SelectComponente';
import CampoFecha from "../../../generico/Fecha";
import { separadorPuntoMiles } from "../../../generico/utils/FormatoInput";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

let datosSocio = JSON.parse(sessionStorage.getItem('socio'));
export default class AgregarSubsidioPaso1 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.getCuentasSocio = this.getCuentasSocio.bind(this);
    this.getTipoSubsidio = this.getTipoSubsidio.bind(this);
  }

  getInitialState = () => ({
    cuentasOrigen: [],
    modalidadElegida: null,
    optionsCuentas: [],
    itemSelected: [],
    cuentasTipo: [],
    optionsTipo: [],
    clasesOptions: [],
    cargaModalidad: undefined,
    tipo: undefined,
    prestamos: undefined,
    tc: undefined,
    ruedas: undefined,
    ahorros: undefined,
    cuentaOrigenSelected: undefined,
    descripcion: undefined,
    importe: undefined,
    datosCuenta: undefined,

    // Nuevos:
    nroTipoSubsidio: undefined,
    nroClaseSubsidio: undefined,
    tipoDescripcion: undefined,
    claseDescripcion: undefined,
    cantDiasMin: undefined,
    cantDiasMax: undefined,
    nroCedula: datosSocio.numeroCedula,
    fechaHecho: undefined,
    showNacimiento: false,
    showMatrimonio: false,
    disableSgte: true,
  });

  componentDidMount() {
    this.getCuentasSocio();
    this.getTipoSubsidio();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  /********************
   * CUENTA A DEBITAR *
   ********************/

  selectorValue = (dataFromChild, item) => {
    if (dataFromChild === undefined) {
      this.setState({
        cuentaOrigenSelected: undefined,
        cuentaDebito: undefined,
        saldoActual: undefined,
        detalleCuenta: undefined,
        itemSelected: undefined,
        datosCuenta: undefined
      });
      return;
    }

    var valores = item.label;
    var resultado = valores.split("-");
    var monto = resultado[2].split(":");

    //console.log(dataFromChild)
    //console.log(item)
    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.cuenta,
        saldoActual: monto[1],
        detalleCuenta: item.label,
        itemSelected: item,
        datosCuenta: item.data
      },
      () => {
        this.handleValicacion();
      }
    );
  };


  /************************
   * OBTENER CUENTAS SOCIO *
   ************************/

  getCuentasSocio() {
    let options = [];
    trackPromise(
      SubsidiosService.getCuentas().then((response) => {
        let data = JSON.stringify(response.data);
        let jsonData = JSON.parse(data);
        //console.log(jsonData)
        if (+jsonData.codigo === 0) {
          for (let i = 0; i < jsonData.resultadoAH.length; i++) {
            options.push({
              value: jsonData.resultadoAH[i].ahorro,
              label:
                jsonData.resultadoAH[i].ahorro +
                " - " +
                jsonData.resultadoAH[i].descripcion +
                " - " +
                " Saldo: " +
                formatoSeparadorMilesValue(jsonData.resultadoAH[i].saldoTotal) +
                " " +
                jsonData.resultadoAH[i].moneda +
                ".",
                data: jsonData.resultadoAH[i].ahorro +
                " - " +
                jsonData.resultadoAH[i].descripcion
            });
           //console.log(options)
          }
          this.setState({
            cuentasOrigen: jsonData.resultadoAH,
            optionsCuentas: options,
            tipo: undefined,
          });
        } else {
          Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
          return;
        }
      })
    );
    return options;
  }

  loadDatosSocio = () => {
    if (this.state.optionsCuentas !== undefined)
      return this.state.optionsCuentas;
    else {
      return this.getCuentasSocio();
    }
  };

  /*****************************
   * OBTENER TIPO DE SUBSIDIOS *
   *****************************/

  getTipoSubsidio() {
    var options = [];
    trackPromise(
      SubsidiosService.obtenerTipoSubsidio().then((response) => {
        var data = JSON.stringify(response.data);
        //console.log("datos", data)
        var jsonData = JSON.parse(data);
        if (jsonData.codigo === 0) {
          for (var i = 0; i < jsonData.datos.length; i++) {
            options.push({
              value: jsonData.datos[i].numeroSubsidio,
              label: jsonData.datos[i].descripcion,
            });
          }
          this.setState({ cuentasTipo: jsonData.datos, optionsTipo: options });
        } else {
          Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
          return;
        }
      })
    );
    return options;
  }

  loadTipoSubsidio = () => {
    if (this.state.optionsTipo !== undefined) return this.state.optionsTipo;
    else {
      return this.getTipoSubsidio();
    }
  };

  selectorValues = (dataFromChild, item) => {
    //console.log(dataFromChild)
    if (dataFromChild === undefined) {
      this.setState({
        nroTipoSubsidio: undefined,
      });
      return;
    }

    this.setState(
      {
        disableSgte: true,
        nroClaseSubsidio: undefined,
        nroTipoSubsidio: dataFromChild,
        tipoDescripcion: item.label,
        clasesOptions: []
      },
      () => {
        this.handleValicacion();
      }
    );
    //console.log(dataFromChild)
    this.getClaseSubsidio(dataFromChild);
  };

  /*******************************
   * OBTENER CLASES DE SUBSIDIOS *
   *******************************/

  getClaseSubsidio(nroSubsidio) {
    var options = [];
    trackPromise(
      SubsidiosService.obtenerClaseSubsidio(nroSubsidio).then((response) => {
        var data = JSON.stringify(response.data);
        //console.log("datos", data)
        var jsonData = JSON.parse(data);
        console.log(jsonData)
        if (jsonData.codigo === 0) {
          for (var i = 0; i < jsonData.datos.length; i++) {
            options.push({
              value: jsonData.datos[i].numeroClaseSubs,
              label: jsonData.datos[i].claseDescripcion,
              cantDiasMax: jsonData.datos[i].diasSubsidioMaximo,
              cantDiasMin: jsonData.datos[i].diasSubsidioMinimo,
              montoARecibir: jsonData.datos[i].monto
            });
          }
          this.setState({ clasesOptions: options });
        } else {
          Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
          return;
        }
      })
    );
    return options;
  }

  loadClasesSubsidio = () => {
    if (this.state.clasesOptions !== undefined) {
      return this.state.clasesOptions;
    } else {
      return this.getClaseSubsidio();
    }
  };

  selectorValueClasesSub = (dataFromChild, item) => {
    // console.log(dataFromChild);
    // console.log(item);
    if (dataFromChild === undefined) {
      this.setState({
        nroClaseSubsidio: undefined,
        cantDiasMax: undefined,
        cantDiasMin: undefined,
        montoARecibir: undefined
      });
      return;
    }
    this.setState(
      {
        nroClaseSubsidio: dataFromChild,
        claseDescripcion: item.label,
        cantDiasMax: item.cantDiasMax,
        cantDiasMin: item.cantDiasMin,
        showNacimiento: dataFromChild === 2 ? true : false,
        showMatrimonio: dataFromChild === 3 ? true : false,
        montoARecibir: item.montoARecibir
      },
      () => {
        this.handleValicacion();
      }
    );
  };

/***********************
 * HANDLE CHANGED DATE *
 ***********************/
 handleChangeDate = (dataDate) => {
  this.setState({ fechaHecho: dataDate }, () => {
    this.handleValicacion();
  });
};

  /*********************
   * HANDLE VALIDACION *
   *********************/

  handleValicacion = () => {
    if (
      this.state.cuentaOrigenSelected &&
      this.state.nroTipoSubsidio &&
      this.state.nroClaseSubsidio &&
      this.state.fechaHecho
    )
      this.setState({ disableSgte: false })     
    else {
        this.setState({ disableSgte: true })
      };
  };



  /******************************************
   * CONTINUAR -> CARGA DATOS A SUBSIDIO.JS *
   ******************************************/

  continuar = () => {
    // var options = [];

    // options.push({
    //   cuentaDebito: this.state.detalleCuenta,
    //   saldo: this.state.saldoActual,
    // });
    this.props.respuestaPaso1(
      this.state.datosCuenta,
      datosSocio.numeroCedula,
      this.state.cuentaOrigenSelected,
      this.state.nroTipoSubsidio,
      this.state.nroClaseSubsidio,
      this.state.tipoDescripcion,
      this.state.claseDescripcion,
      this.state.fechaHecho,
      this.state.cantDiasMax,
      this.state.cantDiasMin,
      this.state.montoARecibir
    );

    this.state.nroClaseSubsidio === 2
      ? this.props.goToStep(3)
      : this.state.nroClaseSubsidio === 3
      ? this.props.goToStep(4)
      : this.nextStep.click();
  };

  volverSubsidios = (e) => {
    history.push(ConfigService.getPathByName("solicitudSubsidios")?.url);
    window.location.reload();
  };

  render() {
    let cuentas = this.loadDatosSocio();
    let tipos = this.loadTipoSubsidio();
    let clases = this.loadClasesSubsidio();

    return (
      <div>
        <div className="row">
          <div className="steps clearfix steps-doc">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Cuenta
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      {this.state.showNacimiento
                        ? "Recién Nacido"
                        : this.state.showMatrimonio
                        ? "Datos Cónyuge"
                        : "Datos de Reposo"}
                    </span>
                  </div>
                </span>
              </li>
              {this.state.showNacimiento && (
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos Cónyuge</span>
                    </div>
                  </span>
                </li>
              )}
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    {/* <span className="number">
                      {this.state.showNacimiento ? 4 : 3}
                    </span> */}
                    <span className="title_text">Adjuntar Documentos</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    {/* <span className="number">
                      {this.state.showNacimiento ? 5 : 4}
                    </span> */}
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    {/* <span className="number">
                      {" "}
                      {this.state.showNacimiento ? 6 : 5}{" "}
                    </span> */}
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                {
                  <SelectComponente
                    id="cuenta"
                    titulo="Seleccione la Cuenta a acreditar "
                    presentacion="SELECT"
                    selectorValue={this.selectorValue.bind(this)}
                    itemSelected={this.state.cuentas}
                    options={cuentas}
                  />
                }
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-md-center">
              <div className="col-md-10">
                <div className="form-group">
                  <label className="input-label-bold">Cédula *</label> <br />
                  <label>{separadorPuntoMiles(datosSocio.numeroCedula)}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  {
                    <SelectComponente
                      id="tipoSubsidio"
                      titulo="Tipo de Subsidios"
                      presentacion="SELECT"
                      selectorValue={this.selectorValues.bind(this)}
                      itemSelected={this.state.nroTipoSubsidio}
                      options={tipos}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  {
                    <SelectComponente
                      id="clasesSubsidio"
                      titulo="Clases de Subsidios"
                      presentacion="SELECT"
                      selectorValue={this.selectorValueClasesSub.bind(this)}
                      itemSelected={null}
                      options={clases}
                      //onChangeTipo={this.state.changeTipoSubsidio}
                    />
                  } 
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row justify-content-md-center">
                <div className="col-md-10">
                  <div className="form-group">
                    <label className="input-label-bold">Fecha Hecho *</label>
                    <CampoFecha onChange={this.handleChangeDate} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-md-center">
              <div className="col-lg-8 col-md-6">
                <label className="input-label-bold-obligatorio float-left">
                  (*) Campos Obligatorios
                </label>
              </div>
              <div className="col-lg-2 col-md-3 btn-consulta">
              <button
              className="btn btn-cu-quintary"
              style={{ marginRight: "5px" }}
              onClick={this.volverSubsidios}
            >
            <FontAwesomeIcon icon={faArrowLeft} />  Volver al Listado
            </button>
              </div>
              <div className="col-lg-2 col-md-3">
              <button
              disabled={this.state.disableSgte}
              className="btn btn-cu-primary float-right"
              onClick={() => {
                this.continuar();
              }}
            >
              Continuar <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
              </div>
            </div>
          </div>
        </div>

      

       
      </div>
    );
  }
}